import React from 'react';
import PropTypes from 'prop-types';
//Components
import moment from 'moment';
import Loader from 'components/loader';
import {connectToPOSPermissions, POS_PERMISSIONS} from 'helpers/posPermissions';
import SummarySectionPOSDate from '../components/summarySectionPosDate.jsx';
import ReportApi from 'api/report';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {makeCancelable} from 'helpers/cancelablePromise';
import ReportErrorHandler from '../components/reportErrorHandler';
import {scheduleReports, scheduleReportExportURL, scheduleReportsStatuses} from 'helpers/constants.jsx';
import BulletList from 'helpers/bulletList.jsx';

class MissedProductSales extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    dealer: PropTypes.object,
    POSActive: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      archivedReports: [],
      loaded: true,
      showNoDataMessage: false,
      error: false,
      currentReport: null,
    };
  }

  componentDidMount = () => {
    const {locale} = this.props.intl;
    const exportURLKey = locale === 'fr-CA' ? scheduleReportExportURL.XLSX_FR : scheduleReportExportURL.XLSX;

    this.setState({
      loaded: false,
      error: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    } else {
      this.setState({
        archivedReports: [],
        currentReport: null,
      });
    }

    (this.fetching = makeCancelable(ReportApi.getScheduledReportDetails([
      scheduleReports.MissedProductSales,
    ])))
      .then(res => {
        if (res && res.length) {
          const currentReport = res.find(r => r.Status === scheduleReportsStatuses.COMPLETED && r[exportURLKey]);
          const archivedReports = res.filter(r => r.Status !== scheduleReportsStatuses.COMPLETED && r[exportURLKey]);
          const noDataAvailable = (!archivedReports || !archivedReports.length) && !currentReport;

          this.setState({
            archivedReports,
            currentReport,
            showNoDataMessage: noDataAvailable,
            error: false,
            loaded: true,
          });

        } else {
          this.setState({loaded: true, showNoDataMessage: true, error: false});
        }
      }).catch((e) => {
        console.log(e);
        if (e && e.canceled) { return; }
        this.setState({loaded: true, error: true});
      });
  }

  componentWillUnmount() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    this.setState({
      error: true,
      loaded: true,
    });
  }

  export = (URL) => {
    window.open(URL, '_blank');
  }

  getArchiveTag = (date) => {
    return moment(date).utc().format('YYYY');
  }

  render() {
    const {archivedReports, currentReport, showNoDataMessage} = this.state;
    const {locale} = this.props.intl;
    const exportURLKey = locale === 'fr-CA' ? scheduleReportExportURL.XLSX_FR : scheduleReportExportURL.XLSX;

    return (
      <div className="report-container">
        <div className='description'>
          <FormattedMessage id="reports.missed.products.description" />
        </div>
        <div>
          <FormattedMessage id="reports.thingstoknow" />
          <FormattedMessage id="reports.thingstoknow.missed-products">
            {x => <BulletList text={x} />}
          </FormattedMessage>
        </div>
        <Loader loaded={this.state.loaded}>
          <ReportErrorHandler error={this.state.error}>
            <SummarySectionPOSDate POSActive={this.props.POSActive} dealer={this.props.dealer} />
            {showNoDataMessage ?
              <label className='report-no-data'><FormattedMessage id="reports.error.no.results" /></label> : null}
            {currentReport ?
              <div>
                <div className='col-sm-12 button-group shift-right'>
                  <button className='btn btn-primary pull-right'
                    onClick={() => this.export(currentReport[exportURLKey])}>
                    <FormattedMessage id='general.download' />
                  </button>
                </div>
              </div> : null}
            {archivedReports && archivedReports.length ?
              <div className='summary-container'>
                <h2><FormattedMessage id='reports.archived' /></h2>
                <div className='container-fluid custom-container-margins'>
                  <div className='row'>
                    <div className='col-sm-12 reports-archive-list'>
                      <ul>
                        {archivedReports.map((r, i) => {
                          return <li key={i}>
                            <a href={r[exportURLKey]} download>{this.getArchiveTag(r.Created)}</a>
                          </li>;
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div> : null}
          </ReportErrorHandler>
        </Loader>
      </div>
    );
  }
}


export default injectIntl(connectToPOSPermissions(POS_PERMISSIONS.DETAILED_REPORTING)(MissedProductSales));